import React, { useState, useRef, useEffect}  from 'react';
import { Form } from 'react-bootstrap';
import FormGroup from '.';
import i18n from '../../locales';
import TextError from '../Text/TextError';
import { checkCPF } from '../../services/User';

let isChanging = false
let isBlur = false


const _checkValidCPF = (value, controlId, setIsInvalid, setErrorMsgState, isInvalid) => {
    //  
    if(controlId === 'document' && value.length > 10) {
        if(checkCPF(value)) {
            if(isInvalid) setIsInvalid(false)
        } else {
            setErrorMsgState(i18n.t('user_form.errors.cpf_invalid'))
            if(!isInvalid) setIsInvalid(true)
        }
    }
}

const InputText = ({text, 
    controlId, 
    required, 
    errorMsg, 
    value, 
    objectId, 
    inputChangeEnd, 
    isEditing, 
    cancelFields, 
    hasUpdate, 
    disabled, 
    onKeyPress, 
    minLength,
    maxLength}) => {

    let _getRef = useRef()
    let [isActive, setIsActive] = useState(false)
    let [isInvalid, setIsInvalid] = useState(false)
    let invalidMsg = errorMsg ? errorMsg : i18n.t('vehicle_form.errors.required')
    let [errorMsgState, setErrorMsgState] = useState(invalidMsg)

    useEffect(() => {
        
        if(cancelFields && !isChanging && !value) _getRef.current.value = '';

        if(cancelFields || hasUpdate) {
            if(isInvalid) setIsInvalid(false)
            isBlur = false
        }

        if( _getRef.current) {
            if(!value && _getRef.current.value === '') {
                if(isActive) setIsActive(false)
            } 
        }

        if(value && !cancelFields) {
            if(!isChanging && isEditing && !isBlur) {
                _getRef.current.value = value
            }
            if(!isActive && _getRef.current.value !== '') setIsActive(true)
        }

    });

    return (
        <FormGroup 
            controlId={controlId}
            labelText={text}
            placeholder={text}
            isActive={isActive}
            required={required}
            >
            <Form.Control
                ref={_getRef}
                className='floating-label' 
                type='text' 
                required={required}
                isInvalid={(isInvalid && !cancelFields)}
                minLength={minLength || '1'}
                maxLength={maxLength || '100'}
                disabled={disabled}
                onBlur={((e)=> {
                    isBlur = true
                    isChanging = false
                    if(e.target.value.length < 1 || e.target.value < 1) {
                        if(e.target.value.length < 1) {
                            setIsActive(false)
                            setErrorMsgState(i18n.t('vehicle_form.errors.required'))
                        } else {
                            setErrorMsgState(i18n.t('general.invalid_vin'))
                        }
                        if(required && !isInvalid) setIsInvalid(true)
                    }
                    _checkValidCPF(e.target.value, controlId, setIsInvalid,setErrorMsgState, isInvalid)
                    inputChangeEnd(e, isInvalid) 
                })}
                onKeyPress={(e) => {
                    if(!onKeyPress) return 
                    if(_getRef.current.value.length === 16) {
                        _getRef.current.value = e.target.value + e.key
                    }
                    _checkValidCPF(e.target.value, controlId, setIsInvalid,setErrorMsgState, isInvalid)
                    onKeyPress(e)
                }}
                onChange={(item) => {
                    isChanging = true
                    if(item.target.value.length > 0) {
                        _getRef.current.value = item.target.value
                        setIsActive(true)
                        if(isInvalid) setIsInvalid(false)
                        _checkValidCPF(item.target.value, controlId, setIsInvalid,setErrorMsgState, isInvalid)
                    } else {
                        setErrorMsgState(i18n.t('vehicle_form.errors.required'))
                        if(!isInvalid) setIsInvalid(true)
                    }
                    inputChangeEnd(item, isInvalid) 
                }}/>
            <Form.Control.Feedback type="invalid">
                <TextError text={errorMsgState}/>
            </Form.Control.Feedback>
        </FormGroup>
    )
}

export default InputText;